import { useNavigate } from 'react-router-dom';
import { useDialog } from '../components/GlobalAlertProvider';
import { useToast } from '../components/ToastContext';
import {
  useAddsvcControllerDeviceinfo,
  useAddsvcControllerModify,
  useAddsvcControllerOrder,
  useAddsvcControllerSubscribe,
} from '../generated/endpoint';
import { ModifyReqDto, OrderUpdateReqDto } from '../generated/model';

export function useInfoService() {
  const toast = useToast();
  const { showAlert } = useDialog();

  const { data: dataTariff, isLoading, error } = useAddsvcControllerSubscribe();

  const { data: deviceInfo, isLoading: deviceInfoLoading, error: deviceInfoError } = useAddsvcControllerDeviceinfo();

  const navigate = useNavigate();

  const {
    mutate,
    isSuccess: modifySuccess,
    error: modifyError,
  } = useAddsvcControllerModify({
    mutation: {
      onSuccess: () => {
        toast('변경되었어요.');
      },
      onError: () => {
        toast('오류가 발생했어요.');
      },
    },
  });

  // 부가서비스 주문용 뮤테이션
  const {
    mutate: orderMutate,
    isSuccess: orderSuccess,
    error: orderError,
  } = useAddsvcControllerOrder({
    mutation: {
      onSuccess: (rst) => {
        if (rst.result === true) {

          showAlert('부가서비스 신청 완료', '부가서비스 신청이 완료되었습니다.').then(() => {            
            window.location.assign('http://command/close');
          });
        } else {
          console.log("부가서비스 신청 후 결과",JSON.stringify(rst, null, 2));
          if (rst.error === 'INVALID_ADDR') {
            toast("유효하지 않은 주소정보입니다.");
          } else if (rst.error === 'OVER_LENGTH_ADDR') {
            toast("주소 정보가 너무 깁니다.");
          } else {
            toast('부가서비스 신청에 실패했어요.');
          }
        }
      },
      onError: () => {
        toast('오류가 발생했어요.');
      },
    },
  });

  const onSubmit = (formData: ModifyReqDto) => {
    mutate({ data: formData });
  };

  const onOrder = (orderData: OrderUpdateReqDto) => {
    orderMutate({ data: orderData });
  };

  return {
    tariff: dataTariff?.payload,
    deviceInfo: deviceInfo?.payload,
    onSubmit,
    onOrder,
    orderSuccess,
    orderError,
    modifySuccess,
  };
}
